// Devina asked (2026-08-28) to simplify the booking/enrollment flow to just "create a backend
// record" until a payment gateway is actually chosen and wired up: no visible pricing, no
// WhatsApp phone verification step, no visible payment/demo-payment step. Front-end only, by
// explicit instruction -- functions/src/callable/createHold.ts and enrollInBatch.ts are
// unchanged and still require a signed-in, recently-verified phone (see isPhoneRecentlyVerified
// in functions/src/otp.ts). With REQUIRE_PHONE_VERIFICATION off, those calls have no way to
// authenticate and will be rejected server-side -- a known, explicitly accepted consequence of
// this front-end-only change, not a bug.
//
// Flip these back to restore the removed behavior; nothing referencing them was deleted.
export const SHOW_PRICING = false;
export const REQUIRE_PHONE_VERIFICATION = false;
// When false, a created hold/enrolment skips the visible payment and demo-payment steps and
// goes straight to "confirmed" (still calling the same real startPaymentForBooking /
// confirmDemoPayment functions under the hood, just without a customer-facing button for it).
export const SHOW_PAYMENT_STEP = false;
